// extracted by mini-css-extract-plugin
export default {"button":"OverlayButton_button__5xq+C"};